export const environment = {
  production: true,
  serverUrl: 'https://api.test.zotapay.dx-compliance.com/v1',
  kibana: {
    mlro: 'https://test.zotapay.dx-compliance.com/kibana/app/dashboards#/view/47404360-bbfc-11ed-afc8-8d4d6413f1d9?embed=true&_g=(filters%3A!()%2CrefreshInterval%3A(pause%3A!t%2Cvalue%3A0)%2Ctime%3A(from%3Anow-15m%2Cto%3Anow))',
    leadership: 'https://test.zotapay.dx-compliance.com/kibana',
    chartArray: [
      'https://test.zotapay.dx-compliance.com/kibana',
      'https://test.zotapay.dx-compliance.com/kibana',
      'https://test.zotapay.dx-compliance.com/kibana',
      'https://test.zotapay.dx-compliance.com/kibana',
    ],
  },
  // Neo4j direct-connect is disabled; credentials are provisioned by the backend.
  // To re-enable, add a backend endpoint that returns { url, username, password }
  // and pass them to connectDriver(url, username, password) in the component.
};
